"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeBuilder = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const react_vtree_1 = require("react-vtree");
const ButtonGroup_1 = __importDefault(require("@material-ui/core/ButtonGroup"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const ControlPoint_1 = __importDefault(require("@material-ui/icons/ControlPoint"));
const detail_action_button_1 = require("../../composite/action-button/detail/detail-action-button");
const form_panel_1 = require("../../composite/form/fields/form-panel");
const table_field_toolbar_button_1 = require("../table-field/table-field-toolbar-button");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const tree_builder_dialog_1 = require("./tree-builder-dialog");
const tree_builder_item_1 = require("./tree-builder-item");
const tree_context_1 = require("./tree-context");
const tree_styles_1 = require("./tree-styles");
function TreeBuilder(props) {
    const intl = (0, react_intl_1.useIntl)();
    const { source, disabled } = props;
    const classes = (0, tree_styles_1.useStyles)();
    const [selectedNode, setSelectedNode] = (0, react_1.useState)(null);
    const addNode = (0, event_callback_hook_1.useEventCallback)((item) => {
        setSelectedNode(item);
        setTimeout(() => {
            var _a;
            (_a = addNodeRef.current) === null || _a === void 0 ? void 0 : _a.executeAction();
        });
    });
    const updateNode = (0, event_callback_hook_1.useEventCallback)((item) => {
        setSelectedNode(item);
        setTimeout(() => {
            var _a;
            (_a = updateNodeRef.current) === null || _a === void 0 ? void 0 : _a.executeAction();
        });
    });
    const addNodeRef = (0, react_1.useRef)(null);
    const updateNodeRef = (0, react_1.useRef)(null);
    return (react_1.default.createElement(form_panel_1.FormPanel, { label: intl.formatMessage({
            id: 'EAS__TREE_BUILDER',
            defaultMessage: 'Hierarchie',
        }) },
        react_1.default.createElement("div", { className: classes.builder },
            react_1.default.createElement("div", { className: classes.builderActions },
                react_1.default.createElement(ButtonGroup_1.default, { className: classes.buttonGroup },
                    react_1.default.createElement(detail_action_button_1.DetailActionButton, { promptKey: "EAS__TREE_BUILDER__ADD_ROOT_NODE", callback: (values) => {
                            source.insertAsync(source.rootId, values);
                        }, buttonLabel: intl.formatMessage({
                            id: 'EAS__TREE_BUILDER__ADD_ROOT_NODE',
                            defaultMessage: 'Přidat přímého potomka',
                        }), dialogTitle: intl.formatMessage({
                            id: 'EAS__TREE_BUILDER__ADD_ROOT_NODE__TITLE',
                            defaultMessage: 'Přidat uzel',
                        }), dialogText: intl.formatMessage({
                            id: 'EAS__TREE_BUILDER__ADD_ROOT_NODE__TEXT',
                            defaultMessage: 'Vyplňte název',
                        }), formInitialValues: {
                            parent: null,
                        }, ButtonComponent: ({ onClick, label }) => (react_1.default.createElement(table_field_toolbar_button_1.TableFieldToolbarButton, { IconComponent: ControlPoint_1.default, show: true, disabled: false, title: label, onClick: onClick, color: "primary", variant: "contained" },
                            react_1.default.createElement(Typography_1.default, { variant: "body2" }, intl.formatMessage({
                                id: 'ES__NOTES_TOOLBAR__ADD_NOTE__BUTTON',
                                defaultMessage: 'Přidat',
                            })))), FormFields: tree_builder_dialog_1.TreeBuilderDialog }),
                    react_1.default.createElement(detail_action_button_1.DetailActionButton, { ref: addNodeRef, promptKey: "EAS__TREE_BUILDER__ADD_NODE", callback: (values) => {
                            source.insertAsync(values.parent.id, values);
                        }, buttonLabel: intl.formatMessage({
                            id: 'EAS__TREE_BUILDER__ADD_NODE',
                            defaultMessage: 'Přidat uzel',
                        }), dialogTitle: intl.formatMessage({
                            id: 'EAS__TREE_BUILDER__ADD_NODE__TITLE',
                            defaultMessage: 'Přidat uzel',
                        }), dialogText: intl.formatMessage({
                            id: 'EAS__TREE_BUILDER__ADD_NODE__TEXT',
                            defaultMessage: 'Vyplňte název (nadřazený uzel: {node})',
                        }, { node: selectedNode === null || selectedNode === void 0 ? void 0 : selectedNode.label }), formInitialValues: {
                            parent: selectedNode,
                        }, FormFields: tree_builder_dialog_1.TreeBuilderDialog, modes: [] }),
                    react_1.default.createElement(detail_action_button_1.DetailActionButton, { ref: updateNodeRef, promptKey: "EAS__TREE_BUILDER__UPDATE_NODE", callback: (values) => {
                            source.updateAsync(values.id, values);
                        }, buttonLabel: intl.formatMessage({
                            id: 'EAS__TREE_BUILDER__UPDATE_NODE',
                            defaultMessage: 'Upravit uzel',
                        }), dialogTitle: intl.formatMessage({
                            id: 'EAS__TREE_BUILDER__UPDATE_NODE__TITLE',
                            defaultMessage: 'Upravit uzel',
                        }), dialogText: intl.formatMessage({
                            id: 'EAS__TREE_BUILDER__UPDATE_NODE__TEXT',
                            defaultMessage: 'Upravit název',
                        }), formInitialValues: {
                            ...selectedNode,
                        }, FormFields: tree_builder_dialog_1.TreeBuilderDialog, modes: [] }))),
            react_1.default.createElement(tree_context_1.TreeContext.Provider, { value: props },
                source.items.length > 0 && (react_1.default.createElement(react_vtree_1.FixedSizeTree, { treeWalker: () => source.treeWalker(), itemSize: 26, height: 300, width: "100%", async: true, itemData: {
                        disabled,
                        addNode,
                        updateNode,
                    } }, tree_builder_item_1.TreeBuilderItem)),
                source.items.length === 0 && (react_1.default.createElement("div", { className: classes.noMatch },
                    react_1.default.createElement(Typography_1.default, null,
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__TREE_BUILDER__EMPTY_SUB_TREE", defaultMessage: "Nejsou dostupn\u00E9 \u017E\u00E1dn\u00E9 z\u00E1znamy." }))))))));
}
exports.TreeBuilder = TreeBuilder;
//# sourceMappingURL=tree-builder.js.map